import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { fullscreen } from '@wordpress/icons';

function BlockFullHeightAlignmentToolbar(_ref) {
  var isActive = _ref.isActive,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? __('Toggle full height') : _ref$label,
      onToggle = _ref.onToggle;
  return createElement(ToolbarGroup, null, createElement(ToolbarButton, {
    isActive: isActive,
    icon: fullscreen,
    label: label,
    onClick: function onClick() {
      return onToggle(!isActive);
    }
  }));
}

export default BlockFullHeightAlignmentToolbar;
//# sourceMappingURL=index.js.map